<template>
    <section class="onboarding-wrapper onboarding-de onboarding-de-new" :class="{ 'is-terminal': isTerminal }">
        <progress-bar
            v-if="!isTerminal"
            :question-number="progressStep"
            :number-of-tabs="progressTotal"
            :show-back-button="canGoBack"
            @goBack="goBack"
        ></progress-bar>

        <div v-else class="progress-bar-header onboarding-header">
            <div class="container">
                <a href="#" class="progress-back" v-if="canGoBack" @click.prevent="goBack">
                    <span class="material-symbols-rounded">west</span>
                    <span class="progress-back-text">Zurück</span>
                </a>

                <div class="site-header-contact">
                    <div>
                        <figure>
                            <span class="material-symbols-rounded">phone</span>
                        </figure>

                        <div class="contact-text">
                            <a href="tel:0158 88 72 57 51">0158 88 72 57 51</a>
                            <div v-if="isAvailable" class="online">
                                <span></span>
                                <p>Jetzt erreichbar</p>
                            </div>
                            <small v-else>Mo-Fr, 9:00-17:00 Uhr</small>
                        </div>
                    </div>

                    <div>
                        <figure>
                            <span class="material-symbols-rounded">mail</span>
                        </figure>

                        <div class="contact-text">
                            <a href="mailto:kontakt@vitadio.de">kontakt@vitadio.de</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <step-age             v-if="is('age')"         @answer="onAge"></step-age>
            <step-testimonial     v-if="is('testimonial')" :variant="testimonialVariant" @answer="next('diabetes')"></step-testimonial>
            <step-diabetes        v-if="is('diabetes')"    @answer="onDiabetes"></step-diabetes>
            <step-not-eligible    v-if="is('notEligible')"></step-not-eligible>
            <step-dmp             v-if="is('dmp')"         @answer="onDmp"></step-dmp>
            <step-access          v-if="is('access')"      @answer="next('insurance')"></step-access>
            <step-insurance       v-if="is('insurance')"   @answer="onInsurance"></step-insurance>
            <step-free            v-if="is('free')"        @answer="next('name')"></step-free>
            <step-name            v-if="is('name')"        :value="answers.name" @answer="onName"></step-name>
            <step-code            v-if="is('code')"        @answer="onCode"></step-code>
            <step-code-help       v-if="is('codeHelp')"    @answer="next('email')"></step-code-help>
            <step-email           v-if="is('email')"       :sending="sending" :errors="errors" @answer="onEmail"></step-email>
            <step-next-steps      v-if="is('nextSteps')"   @answer="next('phone')"></step-next-steps>
            <step-phone           v-if="is('phone')"       :sending="sending" :errors="errors" @answer="onPhone"></step-phone>
            <step-document        v-if="is('document')"    @answer="onDocument"></step-document>
            <step-go-medicus      v-if="is('goMedicus')"></step-go-medicus>
            <step-rezept-service  v-if="is('rezeptService')"></step-rezept-service>

            <onboarding-question-download-app v-if="is('download')"></onboarding-question-download-app>
        </div>

        <onboarding-welcome-modal v-if="!jumped"></onboarding-welcome-modal>
    </section>
</template>

<script>
import OnboardingWelcomeModal from './OnboardingWelcomeModal'
import StepAge from './StepAge'
import StepTestimonial from './StepTestimonial'
import StepDiabetes from './StepDiabetes'
import StepNotEligible from './StepNotEligible'
import StepDmp from './StepDmp'
import StepAccess from './StepAccess'
import StepInsurance from './StepInsurance'
import StepFree from './StepFree'
import StepName from './StepName'
import StepCode from './StepCode'
import StepCodeHelp from './StepCodeHelp'
import StepEmail from './StepEmail'
import StepNextSteps from './StepNextSteps'
import StepPhone from './StepPhone'
import StepDocument from './StepDocument'
import StepGoMedicus from './StepGoMedicus'
import StepRezeptService from './StepRezeptService'
import OnboardingQuestionDownloadApp from '../OnboardingDeTypeA/OnboardingQuestionDownloadApp'

const MAIN_PATH = [
    'age', 'testimonial', 'diabetes', 'dmp', 'access', 'insurance',
    'free', 'name', 'code', 'codeHelp', 'email', 'nextSteps', 'phone', 'document'
]

const OUTCOME = ['rezeptService', 'goMedicus']

const EXIT = ['notEligible', 'download']

const AGE_BANDS = {
    '18-29': 18,
    '30-44': 30,
    '45-59': 45,
    '60+': 60
}

export default {
    props: {
        debug: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {
        OnboardingWelcomeModal,
        StepAge, StepTestimonial, StepDiabetes, StepNotEligible, StepDmp,
        StepAccess, StepInsurance, StepFree, StepName, StepCode, StepCodeHelp,
        StepEmail, StepNextSteps, StepPhone, StepDocument, StepGoMedicus,
        StepRezeptService, OnboardingQuestionDownloadApp
    },

    data() {
        return {
            step: 'age',
            jumped: false,
            history: [],
            sending: false,
            errors: {},
            formId: null,
            token: null,
            answers: {
                ageBand: null,
                diabetes: null,
                dmp: null,
                insuranceCompanyId: null,
                insuranceCompanyName: null,
                name: null,
                hasCode: null,
                email: null,
                agreements: false,
                phone: null,
                phoneCountry: null,
                hasDocument: null
            }
        }
    },

    computed: {
        testimonialVariant() {
            return this.answers.ageBand === '60+' ? 'men' : 'woman'
        },

        progressTotal() {
            return MAIN_PATH.length + 1
        },

        progressStep() {
            const i = MAIN_PATH.indexOf(this.step)

            if (i !== -1) {
                return i + 1
            }

            if (OUTCOME.indexOf(this.step) !== -1) {
                return this.progressTotal
            }

            for (let n = this.history.length - 1; n >= 0; n--) {
                const j = MAIN_PATH.indexOf(this.history[n])

                if (j !== -1) {
                    return j + 1
                }
            }

            return 1
        },

        progressPercent() {
            return Math.round((this.progressStep / this.progressTotal) * 100)
        },

        isTerminal() {
            return EXIT.indexOf(this.step) !== -1
        },

        isAvailable() {
            const now = new Date()
            const day = now.getDay()
            const currentTime = now.getHours() * 60 + now.getMinutes()

            return (day !== 0 && day !== 6) && (currentTime > 9 * 60 && currentTime < 17 * 60)
        },

        canGoBack() {
            return this.history.length > 0
        }
    },

    created() {
        this.jumpToStepFromUrl()
    },

    methods: {
        jumpToStepFromUrl() {
            if (!this.debug) {
                return
            }

            const step = new URLSearchParams(window.location.search).get('step')

            const knownSteps = MAIN_PATH.concat(OUTCOME, EXIT)

            if (!step || knownSteps.indexOf(step) === -1) {
                return
            }

            Object.assign(this.answers, {
                ageBand: '45-59',
                diabetes: true,
                dmp: true,
                insuranceCompanyId: 1,
                insuranceCompanyName: 'Techniker Krankenkasse (TK)',
                name: 'Max Mustermann',
                hasCode: false,
                email: 'max.mustermann@example.com'
            })

            const i = MAIN_PATH.indexOf(step)
            this.history = i > 0 ? MAIN_PATH.slice(0, i) : []
            this.step = step
            this.jumped = true
        },

        is(step) {
            return this.step === step
        },

        next(step) {
            this.history.push(this.step)
            this.step = step
            this.errors = {}
            this.scrollTop()
        },

        goBack() {
            if (!this.history.length) {
                window.location.href = '/'

                return
            }

            this.step = this.history.pop()
            this.errors = {}
            this.scrollTop()
        },

        scrollTop() {
            if (typeof $ !== 'undefined' && $('#page').length) {
                $('html, body').animate({ scrollTop: $('#page').offset().top }, 0)
            }
        },

        onAge(band) {
            this.answers.ageBand = band
            this.next('testimonial')
        },

        onDiabetes(hasDiabetes) {
            this.answers.diabetes = hasDiabetes
            this.next(hasDiabetes ? 'dmp' : 'notEligible')
        },

        onDmp(inDmp) {
            this.answers.dmp = inDmp
            this.next('access')
        },

        onInsurance(company) {
            this.answers.insuranceCompanyId = company.id
            this.answers.insuranceCompanyName = company.name
            this.next('free')
        },

        onName(name) {
            this.answers.name = name
            this.next('code')
        },

        onCode(hasCode) {
            this.answers.hasCode = hasCode
            this.next(hasCode ? 'download' : 'codeHelp')
        },

        onEmail({ email, agreements }) {
            this.answers.email = email
            this.answers.agreements = agreements
            this.sending = true
            this.errors = {}

            axios
                .post('api/web_pre_registration_form', this.buildPayload(), {
                    headers: { 'Accept-Language': 'de' }
                })
                .then((response) => {
                    this.sending = false
                    this.formId = response.data.form_id
                    this.token = response.data.token
                    this.next('nextSteps')
                })
                .catch((error) => {
                    this.sending = false
                    this.errors = (error.response && error.response.data.errors) || {}
                    Vuemit.fire('Button--sending-failed', true)
                })
        },

        onPhone(phone) {
            this.answers.phone = phone.number
            this.answers.phoneCountry = phone.country

            if (!phone.number) {
                this.next('document')

                return
            }

            this.patch({
                phone: phone.number,
                phone_country: phone.country
            }, 'document')
        },

        onDocument(hasDocument) {
            this.answers.hasDocument = hasDocument

            if (hasDocument) {
                this.storePrefill()
            }

            this.patch({
                has_diagnosis_document: hasDocument
            }, hasDocument ? 'rezeptService' : 'goMedicus')
        },

        storePrefill() {
            const name = (this.answers.name || '').trim().split(/\s+/)

            try {
                sessionStorage.setItem('vitadio.prescriptionPrefill', JSON.stringify({
                    firstName: name.shift() || '',
                    lastName: name.join(' '),
                    email: this.answers.email || '',
                    phone: this.answers.phone || '',
                    insuranceCompanyId: this.answers.insuranceCompanyId,
                    insuranceCompanyName: this.answers.insuranceCompanyName || ''
                }))
            } catch (e) {
            }
        },

        patch(data, target) {
            if (!this.formId) {
                this.next(target)

                return
            }

            this.sending = true
            this.errors = {}

            axios
                .post(`api/web_pre_registration_form/${this.formId}`, Object.assign({ token: this.token }, data), {
                    headers: { 'Accept-Language': 'de' }
                })
                .then(() => {
                    this.sending = false
                    this.next(target)
                })
                .catch((error) => {
                    this.sending = false
                    this.errors = (error.response && error.response.data.errors) || {}
                    Vuemit.fire('Button--sending-failed', true)
                })
        },

        buildPayload() {
            const payload = {
                name: this.answers.name,
                email: this.answers.email,
                agreements: this.answers.agreements,
                variant: 'de-new',
                ga_client_id: null,
                gcl_id: null
            }

            if (this.answers.ageBand) {
                payload.age = AGE_BANDS[this.answers.ageBand]
            }

            if (this.answers.dmp !== null) {
                payload.dmp = this.answers.dmp
            }

            if (this.answers.insuranceCompanyId) {
                payload.insurance_company_id = this.answers.insuranceCompanyId
            }

            if (this.answers.hasCode !== null) {
                payload.has_code = this.answers.hasCode
            }

            const gaCookie = window.getCookie('_ga')
            const gclCookie = window.getCookie('_gcl_aw')

            if (gaCookie !== '' && gaCookie !== 'undefined') {
                payload.ga_client_id = gaCookie
            }

            if ((gclCookie !== 'undefined' && gclCookie !== '') && payload.ga_client_id === gaCookie) {
                payload.gcl_id = gclCookie
            }

            return payload
        }
    }
}
</script>
